// eslint-disable-next-line no-restricted-imports
import type { List } from '@gonfalon/immutable-shim/immutableShim';
// oxlint-disable-next-line no-restricted-imports
import { fromJS, Map } from '@gonfalon/immutable-shim/immutableShim';
import type { ImmutableServerError } from '@gonfalon/legacy-http-client/httpUtils';
import type { ImmutableMap } from '@gonfalon/legacy-immutable/immutableUtils';

import type { TagsAction } from '#actions/tags';
import registry from '#reducers/registry';
import type { GlobalState } from '#reducers/state';

import '#epics/tags';

export type TagsState = ImmutableMap<{
  kind?: string;
  prefix?: string;
  error?: ImmutableServerError;
  entities?: List<string>;
  isFetching: boolean;
  lastFetched?: number;
}>;

export function tags(
  state: TagsState = fromJS({
    lastFetched: null,
    isFetching: false,
    entities: [],
    error: null,
  }),
  action: TagsAction,
): TagsState {
  switch (action.type) {
    case 'tags/FETCH_TAGS':
      return Map({
        isFetching: true,
        prefix: action.prefix,
        kind: action.kind,
      });
    case 'tags/FETCH_TAGS_DONE':
      return state.merge({
        lastFetched: action.timestamp,
        isFetching: false,
        entities: action.tags,
      });
    case 'tags/FETCH_TAGS_FAILED':
      return state.merge({
        isFetching: false,
        error: action.error,
      });
    default:
      return state;
  }
}

export const tagsSelector = (state: GlobalState) => state.tags;

registry.addReducers({ tags });

declare module '#reducers/state' {
  interface GlobalState {
    tags: ReturnType<typeof tags>;
  }
}
